<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("BUTTONS.addDelivery") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #ef3405">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <h5 class="mt-5 font-weight-bold">
            {{ $t("TITLES.personal_data") }}
          </h5>
          <!-- Start:: Image Upload Input -->
          <base-image-upload-input
            col="12"
            identifier="delivery_man_image"
            :placeholder="$t('PLACEHOLDERS.user_image')"
            @selectImage="selectImage"
          />
          <!-- End:: Image Upload Input -->

          <!-- Start:: Full Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.delivery_name')"
            v-model.trim="data.name"
            required
          />
          <!-- End:: Full Name Input -->

          <!-- Start:: Email Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.delivery_email')"
            v-model.trim="data.email"
          />
          <!-- End:: Email Input -->

          <!-- Start:: Phone Input -->
          <base-input
            ref="phoneInput"
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.delivery_mobile')"
            v-model.trim="data.mobile"
            required
          />
          <!-- End:: Phone Input -->

          <!-- Start:: ID Number -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.id_card_number')"
            v-model.trim="data.id_card_number"
            required
          />
          <!-- End:: ID Number -->

          <!-- Start:: Password Input -->
          <base-input
            col="6"
            type="password"
            :placeholder="$t('PLACEHOLDERS.password')"
            v-model.trim="data.password"
            required
          />
          <!-- End:: Password Input -->

          <!-- Start:: Confirm Password Input -->
          <base-input
            col="6"
            type="password"
            :placeholder="$t('PLACEHOLDERS.confirmPassword')"
            v-model.trim="data.passwordConfirmation"
            required
          />
          <!-- End:: Confirm Password Input -->

          <!-- Start:: Account Status Switch -->
          <!-- <div class="input_wrapper switch_wrapper my-5">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
            ></v-switch>
          </div> -->
          <!-- End:: Account Status Switch -->

          <!-- Start:: Vehicle Details -->
          <hr class="mt-5" style="width: 98%" />
          <h5 class="my-5 font-weight-bold">
            {{ $t("PLACEHOLDERS.vehicle_data") }}
          </h5>
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.vehicle_plate_number')"
            v-model.trim="data.vehicle_plate_number"
            required
          />
          <base-image-upload-input
            col="6"
            identifier="driver_license"
            :placeholder="$t('PLACEHOLDERS.driver_license')"
            @selectImage="selectDriverLicense"
            required
          />
          <!-- End:: Vehicle Details -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "CreateDeliveryMan",

  data() {
    return {
      isWaitingRequest: false,
      data: {
        image: {
          path: null,
          file: null,
          storagePath: null,
          url: null,
        },
        name: null,
        email: null,
        mobile: null,
        password: null,
        passwordConfirmation: null,
        active: true,
        id_card_number: null,
        vehicle_plate_number: null,
        driver_license: {
          path: null,
          file: null,
          storagePath: null,
          url: null,
        },
      },
    };
  },

  computed: {
    ...mapGetters({
      allRoles: "ApiGetsModule/allRoles",
    }),
  },

  methods: {
    // Handle image selection for personal image
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },

    // Handle driver license image selection
    selectDriverLicense(selectedImage) {
      this.data.driver_license = selectedImage;
    },

    // Validate form inputs before submission
    validateFormInputs() {
      this.isWaitingRequest = true;


      this.submitForm();
    },

    // Submit form data
    async submitForm() {
      const formData = new FormData();
      if (this.data.image.storagePath) {
        formData.append("avatar", this.data.image.storagePath);
      }
      formData.append("name", this.data.name);
      if (this.data.email) {
        formData.append("email", this.data.email);
      }
      formData.append("mobile", this.data.mobile);
      formData.append("password", this.data.password);
      formData.append("password_confirmation", this.data.passwordConfirmation);
      // formData.append("is_active", this.data.active ? 1 : 0);
      formData.append("id_card_number", this.data.id_card_number);
      formData.append("vehicle_plate_number", this.data.vehicle_plate_number);
      formData.append("type", "driver");
      formData.append("is_approved_by_admin", 1);

      // Append driver license if provided
      if (this.data.driver_license.storagePath) {
        formData.append("driver_license", this.data.driver_license.storagePath);
      }

      try {
        await this.$axios.post("drivers", formData);
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push("/DeliveryMen/all");
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
  },

  created() {
    // Component initialization
  },
};
</script>
